export const DECISION_OUTCOME_STATUSES = Object.freeze({
  NOT_STARTED: "NOT_STARTED",
  MONITORING: "MONITORING",
  MEASURED: "MEASURED",
  REVIEW_REQUIRED: "REVIEW_REQUIRED",
});

const OUTCOME_STATUS_VALUES = new Set(
  Object.values(DECISION_OUTCOME_STATUSES)
);

function normalizeMeasurementStatus(status) {
  const normalized = String(status || "").trim().toUpperCase();

  return OUTCOME_STATUS_VALUES.has(normalized)
    ? normalized
    : DECISION_OUTCOME_STATUSES.NOT_STARTED;
}

/*
 * Decision outcomes are observations linked to an existing decision. This
 * model deliberately stores values supplied by callers and performs no risk
 * calculation, remediation, or execution activity.
 */
export function createDecisionOutcome({
  expectedImpact = null,
  observedImpact = null,
  variance = null,
  measurementStatus = DECISION_OUTCOME_STATUSES.NOT_STARTED,
  lastUpdated = null,
  decisionMatterId = null,
  createdFromRecommendationId = null,
  sourceRecommendation = null,
} = {}) {
  return {
    expectedImpact,
    observedImpact,
    variance,
    measurementStatus: normalizeMeasurementStatus(measurementStatus),
    lastUpdated,
    decisionMatterId,
    createdFromRecommendationId,
    sourceRecommendation,
  };
}
